import { Component, Injectable, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AprovadorDTO } from 'src/app/models/aprovadorDTO.model';
import { NewAprovadorDTO } from 'src/app/models/newAprovadorDTO.model';
import { AprovadorService } from 'src/app/services/aprovador.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ControlContainer, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Utils } from 'src/app/utils/utils';
import { Page } from 'src/app/models/page.model';
import { sha256 } from 'js-sha256';
import { CandidaturaService } from 'src/app/services/candidatura.service';



@Component({
  selector: 'app-aprovador',
  templateUrl: './aprovador.component.html',
  styleUrls: ['./aprovador.component.css']
})
@Injectable()
export class AprovadorComponent implements OnInit {
  currentLocation: string;
  formCadastroAprovadores: FormGroup;
  formQtAprovadores: FormGroup;
  idCandidatura: any;
  idEleicao: any;
  idGestor: any;
  token: any;
  aprovadores: AprovadorDTO[];
  editandoAprovador: boolean = false;
  idAprovadorEditando: any;
  newAprovadorDTO: NewAprovadorDTO = new NewAprovadorDTO();
  duplicados: any = [];
  retornoDuplicados: boolean = false;
  eleicao: any;
  validaSenha: boolean = false;
  validaLogin: boolean = false;
  validaEmail: boolean = true;
  validaConfirmaSenha: boolean = false;
  validaQtAprovadores: boolean = false;
  public checaValidacao: boolean = true;
  btOff: boolean = false;
  btQtOff: boolean = false;
  model: NewAprovadorDTO = { login: '', email: '', senha: '', auth1: '', auth2: '', candidatura: null };
  public page: Page;
  randomSenha: string;
  carregandoAprovadores: boolean;
  podeEditarAprovador: boolean;
  qtAprovadoresDeferimento: number;

  constructor(
    protected formBuilder: FormBuilder,
    private candidaturaService: CandidaturaService,
    private aprovadorService: AprovadorService,
    protected messageService: MessageService,
    public spinner: NgxSpinnerService,
    public utils: Utils
  ) { }

  async ngOnInit() {
    this.spinner.show();
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.eleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    this.idCandidatura = JSON.parse(sessionStorage.getItem("candidaturaId"));
    this.podeEditarAprovador = this.eleicao.statusEleicao == 'CRIADA' || this.eleicao.statusEleicao == 'ZERESIMA';
    this.idGestor = JSON.parse(sessionStorage.getItem("infoGestor")).id;
    this.token = sessionStorage.getItem("token");
    this.formCadastroAprovadores = new FormGroup({
      loginAprovador: new FormControl(),
      emailAprovador: new FormControl(),
      senhaAprovador: new FormControl(),
      aprovadorauth1: new FormControl(),
      aprovadorauth2: new FormControl(),
      confirmarSenhaAprovador: new FormControl()
    });
    if (sessionStorage.getItem("temCandidaturas")) {
      await this.dadosCandidaturaExistentes();
      //this.validaFormulario();
      this.buscarAprovadoresPorCandidaturaIdPage(10, 0,);
    }
    var qtAprovadores = this.qtAprovadoresDeferimento != null ? this.qtAprovadoresDeferimento : 1;
    this.formQtAprovadores = new FormGroup({
      qtAprovadoresDeferimento: new FormControl(qtAprovadores),
    });
    this.spinner.hide();
  }

  envioAprovador() {
    this.validarLoginAprovador(this.formCadastroAprovadores.get('loginAprovador').value);
    this.validarSenhaAprovador(this.formCadastroAprovadores.get('senhaAprovador').value);
    this.validarEmailAprovador(this.formCadastroAprovadores.get('emailAprovador').value);
    if (this.validaLogin == false || this.validaConfirmaSenha == false) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor preencha o Login e Senha do aprovador.' });
    } else if (this.validaEmail == false) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor preencha um Email válido para o aprovador ou deixe a informação em branco.' });
    } else if (this.validarInformacoesAutenticacao(null) == false) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor preencha tadas Informações de Autenticação com valores válidos.' });
    } else {
      this.btOff = true;
      document.body.style.cursor = 'wait';
      this.newAprovadorDTO.login = this.formCadastroAprovadores.get("loginAprovador").value;
      this.newAprovadorDTO.email = this.formCadastroAprovadores.get("emailAprovador").value;
      this.newAprovadorDTO.senha = sha256.update(this.formCadastroAprovadores.get("senhaAprovador").value).hex();
      this.newAprovadorDTO.auth1 = this.formCadastroAprovadores.get("aprovadorauth1").value;
      this.newAprovadorDTO.auth2 = this.formCadastroAprovadores.get("aprovadorauth2").value;
      this.newAprovadorDTO.candidatura = { "id": this.idCandidatura };
      //this.newEleitorDTO.idGestor = this.idGestor;
      if (this.editandoAprovador == false) {
        this.insertAprovador(this.newAprovadorDTO, this.token);
      } else {
        this.updateAprovador(this.newAprovadorDTO, this.idAprovadorEditando, this.token);
      }
    }
  }

  envioQtAprovadores() {
    this.validarQtAprovadoresDeferimento(this.qtAprovadoresDeferimento);
    if (this.validaQtAprovadores) {
      this.candidaturaService.editarCandidaturaQtAprovadores(this.idCandidatura, this.qtAprovadoresDeferimento, this.token,).then(() => {
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Atenção', detail: "Candidatura editada com sucesso!" });
        setTimeout(function () {
          document.body.style.cursor = 'default';
          window.location.reload();
        }, 1200)
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
        console.log("error", error);
        this.btOff = false;
        document.body.style.cursor = 'default';
      });
    }
  }

  validarLoginAprovador(login: string) {
    const expressaoRegular = /[^A-Za-z0-9\@\.\_\-]/g;

    if (login == null || login == '') {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'É necessário cadastrar um login para o Aprovador.' });
      this.validaLogin = false;
    } else if (expressaoRegular.test(login) == true) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Não é permitido o uso de espaços no login. Os únicos caracteres especiais permitidos são "@", "-", "_" e "."!' });
      this.validaLogin = false;
    } else {
      this.validaLogin = true;
    }
  }

  validarQtAprovadoresDeferimento(qtAprovadoresDeferimento: number) {
    if (qtAprovadoresDeferimento == null || qtAprovadoresDeferimento == 0) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'É necessário informar a quantidade de aprovadores necessária para deferir.' });
      this.validaQtAprovadores = false;
      this.btQtOff = true;
    } else if (this.aprovadores.length < qtAprovadoresDeferimento) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'A quantidade de aprovadores necessária para deferir não pode ser maior que a quantidade de aprovadores cadastrados!' });
      this.validaQtAprovadores = false;
      this.btQtOff = true;
    } else if (isNaN(qtAprovadoresDeferimento)) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'A quantidade de aprovadores deve ser um numeral!' });
      this.validaQtAprovadores = false;
      this.btQtOff = true;
    } else {
      this.qtAprovadoresDeferimento = qtAprovadoresDeferimento;
      this.validaQtAprovadores = true;
      this.btQtOff = false;
    }
  }

  validarEmailAprovador(email: string) {
    const expressaoRegularEmail = /\S+@\S+\.\S+/;
    if (expressaoRegularEmail.test(email) == false && email != '' && email != null) {
      this.validaEmail = false;
    } else {
      this.validaEmail = true;
    }
  }

  validarInformacoesAutenticacao(msg: Number) {
    let a1 = this.utils.noWhitespaceValidatorString(this.formCadastroAprovadores.get("aprovadorauth1").value);
    let a2 = this.utils.noWhitespaceValidatorString(this.formCadastroAprovadores.get("aprovadorauth2").value);
    if (a1 && msg == 1) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor preencha o campo Informação Autenticação 1.' });
      return false;
    }
    if (a2 && msg == 2) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor preencha o campo Informação Autenticação 2.' });
      return false;
    }
    if ((!a1 && !a2 && msg == null)) {
      return true
    }
    return false
  }

  validarSenhaAprovador(senha: string) {
    if (senha == null || senha == '') {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'É necessário cadastrar uma senha.' });
      this.validaSenha = false;
    } else {
      this.validaSenha = true;
    }
  }

  validarConfirmaSenhaAprovador(confirmarSenha: string) {
    let senha = this.formCadastroAprovadores.get("senhaAprovador").value;
    if (confirmarSenha == null || confirmarSenha == '') {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'É necessário corfirmar a senha antes de prosseguir.' });
      this.validaConfirmaSenha = false;
    } else if (senha != confirmarSenha) {
      this.formCadastroAprovadores.get("senhaAprovador").setValue('');
      this.formCadastroAprovadores.get("confirmarSenhaAprovador").setValue('');
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'É necessário que as senhas coincidam. Tente novamente!' });
      this.validaConfirmaSenha = false;
    } else {
      this.validaConfirmaSenha = true;
    }
  }

  editarAprovador(aprovador) {
    this.editandoAprovador = true;
    this.idAprovadorEditando = aprovador.id;
    this.formCadastroAprovadores.get("loginAprovador").setValue(aprovador.login);
    this.formCadastroAprovadores.get("emailAprovador").setValue(aprovador.email);
    this.formCadastroAprovadores.get("senhaAprovador").setValue("");
    this.formCadastroAprovadores.get("aprovadorauth1").setValue(aprovador.auth1);
    this.formCadastroAprovadores.get("aprovadorauth2").setValue(aprovador.auth2);
    this.validaConfirmaSenha = false;
  }

  public cancelarEdicao() {
    this.editandoAprovador = false;
    this.formCadastroAprovadores.reset();
  }

  excluirAprovador(idAprovador) {
    this.btOff = true;
    document.body.style.cursor = 'wait';
    this.aprovadorService.excluirAprovador(idAprovador, this.token).then(() => {
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.buscarAprovadoresPorCandidaturaIdPage(10, 0,);
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Aprovador excluído da eleição com sucesso!' });
    }, err => {
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: err + '.' });
    });
  }

  validaFormulario() {
    if (this.eleicao.statusEleicao != 'EM_ANDAMENTO') {
      this.checaValidacao = true;
    } else {
      this.checaValidacao = false;
    }

  }



  /*baixarTemplate() {
    let csvHeader = 'login;senha;plano;uf;email;autenticacao1;autenticacao2'
    this.utils.baixarModeloCsv(csvHeader, "logins_aprovadores")
  }*/

  public buscarAprovadoresPorCandidaturaId() {

    this.aprovadorService.findAllAprovadoresByCandidaturaId(this.idCandidatura, this.token).then((res: AprovadorDTO[]) => {
      if (res != null && res.length > 0) {
        this.aprovadores = res;
      } else {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Informação', detail: 'Ainda não existem aprovadores cadastros para essa eleição' });

      }
    })
  }

  buscarAprovadoresPorCandidaturaIdPage(linesPerPage: number, page: number) {
    this.carregandoAprovadores = true;
    this.aprovadorService.findAllAprovadoresByCandidaturaIdPage(this.idCandidatura, linesPerPage, page, '', this.token).then((res: any) => {
      if (res.content != null && res.content.length > 0) {
        this.page = res;
        this.aprovadores = res.content;
        this.carregandoAprovadores = false;

      } else {
        this.carregandoAprovadores = false;

        // this.messageService.add({ key: 'toast', severity: 'error', summary: 'Informação', detail: 'Ainda não existem eleitores cadastros para essa eleição' });
      }
    })
  }
  changePage(event) {
    this.buscarAprovadoresPorCandidaturaIdPage(event.size, event.page)
  }
  public filtrarAprovadoresPorNome() {
    var aprovadorBuscado = (<HTMLInputElement>document.getElementById("filtroAprovador")).value;
    this.aprovadorService.findAllAprovadoresByCandidaturaIdPage(this.idCandidatura, 10, 0, aprovadorBuscado, this.token).then((res: any) => {
      if (res.content != null && res.content.length > 0) {
        this.page = res;
        this.aprovadores = res.content;
      } else {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Informação', detail: 'Ainda não existem aprovadores com esse login cadastrado.' });
        this.buscarAprovadoresPorCandidaturaIdPage(10, 0);
      }
    })
  }
  limparFiltro() {
    this.buscarAprovadoresPorCandidaturaIdPage(10, 0);
    (<HTMLInputElement>document.getElementById("filtroAprovador")).value = '';
  }

  gerarSenha() {
    event.preventDefault();
    let senhaGerada = "";
    var caracterLiberado = "0123456789";

    for (var i = 0; i < 6; i++)
      senhaGerada += caracterLiberado.charAt(Math.floor(Math.random() * caracterLiberado.length));

    this.randomSenha = senhaGerada;

  }

  public insertAprovador(aprovador: NewAprovadorDTO, token: any) {
    this.aprovadorService.insertAprovador(aprovador, token).then((resp: any) => {
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.formCadastroAprovadores.reset();
      this.randomSenha = '';
      this.validaSenha = false;
      this.buscarAprovadoresPorCandidaturaIdPage(10, 0,);
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Aprovador enviado com sucesso!' });
    }, err => {
      document.body.style.cursor = 'default';
      this.btOff = false;
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: err.error.message });
      this.formCadastroAprovadores.reset();
      this.randomSenha = '';
      this.validaSenha = false;
    });
  }

  public updateAprovador(aprovador: NewAprovadorDTO, idAprovador: number, token: any) {
    //this.model = eleitor;
    this.aprovadorService.updateAprovador(aprovador, idAprovador, token).then(() => {
      document.body.style.cursor = 'default';
      this.btOff = false;
      this.formCadastroAprovadores.reset();
      this.randomSenha = '';
      this.buscarAprovadoresPorCandidaturaIdPage(10, 0,);
      this.cancelarEdicao();
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Aprovador editado com sucesso!' });
    }, error => {
      document.body.style.cursor = 'default';
      this.btOff = false;
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: 'Nao foi possível editar o aprovador' });
      this.formCadastroAprovadores.reset();
      this.randomSenha = '';
    });
  }
  async dadosCandidaturaExistentes() {
    await this.candidaturaService.listarPorIdEleicao(this.idEleicao, this.token).then((data: any) => {
      this.idCandidatura = data.id;
      this.qtAprovadoresDeferimento = data.qtAprovadoresDeferimento;
    }, err => {
      console.log(err);
    })
  }


  envioAprovadores() {
    if (this.aprovadores.length == 0) {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor carregue uma lista de e-mails para realizar o envio.' });
    } else {
      this.btOff = true;
      // Realiza o Envio
      this.enviarEmails(this.aprovadores, this.token);
    }
  }

  public enviarEmails(e: AprovadorDTO[], token: any) {
    this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'O envio de e-mails está sendo iniciado pela aplicação!' });
    this.aprovadorService.enviarEmailsLoginAprovador(this.idEleicao, e, token).then((res: AprovadorDTO[]) => {
      document.body.style.cursor = 'default';
      this.btOff = false;
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'E-mails enviados com sucesso!' });
    }, error => {
      document.body.style.cursor = 'default';
      this.btOff = false;
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção!', detail: error });
    });
  }


}
